const e = () => "landing-", t = () => `${e()}last-place-info`;
export {
  t as getCacheAddressInfoKey,
  e as getCacheStorePrefix
};
//# sourceMappingURL=shared.js.map
